import { render, staticRenderFns } from "./OrdersModal.vue?vue&type=template&id=a3ac6fcc&scoped=true&"
import script from "./OrdersModal.vue?vue&type=script&lang=js&"
export * from "./OrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersModal.vue?vue&type=style&index=0&id=a3ac6fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ac6fcc",
  null
  
)

export default component.exports